import * as Immutable from 'seamless-immutable';
import {
  TEMPLATE_CATEGORY_CREATE_API_FULFILLED,
  TEMPLATE_CATEGORY_CREATE_API_REJECTED,
  TEMPLATE_CATEGORY_CREATE_START
} from './templates-actions';

const initialState = Immutable.from({
  loading: false
});
export default (state = initialState, action) => {
  switch (action.type) {
    case TEMPLATE_CATEGORY_CREATE_START:
      return state.set('loading', true);
    case TEMPLATE_CATEGORY_CREATE_API_FULFILLED:
    case TEMPLATE_CATEGORY_CREATE_API_REJECTED:
      return state.set('loading', false);
    default:
      return state;
  }
};
